import { Component, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NoEmptyString } from '../../interfaces/no-empty-string.validator';
import { IOrderTag } from '../../interfaces/order-tag';
import { IOrderTagFilter } from '../../interfaces/order-tag-filter';
import { IPageResult } from '../../interfaces/page-result';
import { OrderTagService } from '../../services';
import { LazyLoadEvent } from 'primeng';
import { Table } from 'primeng';
import { Message } from '../../classes/Message';
import { MessageService } from 'primeng/api';
@Component({
  selector: 'job-tags',
  templateUrl: './manage-job-tag.component.html',
})
export class JobTagsComponent implements OnInit {
  public page: IPageResult<IOrderTag> = {
    items: [],
    total: 0,
  };
  //checkDescEndpoint: string;

  public event: any;
  public filter: Subject<IOrderTagFilter>;
  public filterVal: IOrderTagFilter;
  public isLoaded: boolean = false;
  public displayDialog: boolean = false;
  public jobTag: IOrderTag;
  public filterString: string;
  public newJobTagForm: UntypedFormGroup;
  public description: UntypedFormControl;
  public isActive: UntypedFormControl;
  public selectedItem: any;

  constructor(private jobTagService: OrderTagService, private messageService: MessageService) {}

  ngOnInit() {
    this.initDefaultFilter();
    this.filter = new Subject<IOrderTagFilter>();

    // subscribe to filter changes with a debounce time
    this.filter.pipe(debounceTime(500)).subscribe((f) => {
      this.load(f);
      this.filterVal = f;
    });

    // set default filter
    this.filter.next(this.filterVal);

    //this.checkDescEndpoint = this.jobTagService.checkDescEndpoint;
    this.description = new UntypedFormControl(
      '',
      Validators.compose([Validators.required, Validators.maxLength(25), NoEmptyString]),
    );
    this.isActive = new UntypedFormControl(true, Validators.required);

    this.newJobTagForm = new UntypedFormGroup({
      description: this.description,
      isActive: this.isActive,
    });
    this.isLoaded = true;
  }

  load(filter: IOrderTagFilter) {
    this.jobTagService.getPage(filter).then((result) => {
      this.page.items = result.items;
      this.page.total = result.total;
      this.isLoaded = true;
    });
  }

  showDialogToAdd() {
    this.jobTag = { description: '', isActive: true };
    this.resetFormValues(this.jobTag);
    this.displayDialog = true;
  }

  save(formValues) {
    this.jobTag.description = formValues.description.trim();
    this.jobTag.isActive = formValues.isActive;
    if (this.jobTag.description !== '') {
      this.jobTagService
        .create(this.jobTag)
        .then((res) => this.load(this.filterVal))
        .catch((error) => {
          let msg =
            error.error && error.error.Message ? error.error.Message : 'Error saving job tag';
          this.messageService.add(Message.Error(`${msg}`));
        });
    }
    this.displayDialog = false;
  }

  close() {
    this.displayDialog = false;
  }

  resetFormValues(formValues) {
    this.newJobTagForm.setValue({
      description: formValues.description,
      isActive: formValues.isActive,
    });
  }

  onGridLazyLoad(event: LazyLoadEvent) {
    // map grid lazy load event to filter
    //var eventString = JSON.stringify(event);
    //if (eventString === this.filterString) return;
    //console.log(event);
    //this.filter.next(flatten(event));

    this.filterVal.first = event.first;
    this.filterVal.rows = event.rows;
    this.filterVal.sortField = event.sortField;
    this.filterVal.sortOrder = event.sortOrder;

    this.filter.next(this.filterVal);
  }

  onRowSelect(event) {
    this.event = event;
  }

  onRowDblclick(item) {
    this.jobTag = this.cloneValet(item);
    this.resetFormValues(this.jobTag);
    this.displayDialog = true;
  }

  onEdit() {
    if (this.event !== undefined) {
      this.onRowDblclick(this.event.data);
    }
  }

  cloneValet(c: IOrderTag): IOrderTag {
    const jobTag = { id: 0, description: '', isActive: true };
    for (let prop in c) {
      jobTag[prop] = c[prop];
    }

    return jobTag;
  }

  initDefaultFilter() {
    this.filterVal = {
      first: 0,
      rows: 10,
      sortField: 'Name', // ASC
      sortOrder: 1,
      filters: {
        description: {},
        isActive: {},
      },
    };
  }

  clearFilter(dt: Table) {
    dt.sortField = '';
    dt.rows = 10;
    this.initDefaultFilter();
    this.filter.next(this.filterVal);
  }

  search() {
    this.filterVal.first = 0; //fix error - when you set page > 1 and filter, then data not display
    console.log(this.filterVal);
    this.filter.next(this.filterVal);
  }
}
